var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2415_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 4.76465C19.9999 7.10199 19.9999 9.43933 19.9999 11.7772C19.9885 11.7994 19.9707 11.8201 19.966 11.8439C19.7411 12.9412 18.8852 13.6358 17.7512 13.6363C12.5837 13.6368 7.41618 13.6368 2.24866 13.6363C0.945042 13.6363 0.00150761 12.6974 0.000463881 11.4019C-0.000579851 10.2467 0.000463881 9.091 0.000463881 7.93579C0.000463881 6.92912 -5.79851e-05 5.92193 0.000985747 4.91526C0.000985747 4.70358 0.0536942 4.65234 0.264006 4.65027C0.446138 4.64872 0.628269 4.64975 0.810922 4.64975C7.09784 4.64975 13.3848 4.64923 19.6717 4.65441C19.7808 4.65389 19.8904 4.72583 19.9999 4.76465ZM4.05745 10.5376C4.78754 10.5935 5.00934 10.2819 5.01194 9.61633C5.01455 8.90313 4.76458 8.66349 4.05641 8.66504C3.36807 8.6666 3.11235 8.89588 3.11183 9.60754C3.11131 10.3047 3.3618 10.5914 4.05745 10.5376Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.29264C19.8904 3.33094 19.7809 3.4034 19.6713 3.4034C13.6317 3.40857 7.59267 3.40806 1.55311 3.40806C1.12362 3.40806 0.694122 3.40909 0.264626 3.40754C0.0543138 3.40702 -0.00570078 3.35319 0.00212721 3.14306C0.0214363 2.62912 -0.0150944 2.10223 0.0903226 1.60537C0.289154 0.662875 1.17946 0.00245845 2.15222 0.00194088C7.38445 -0.00064696 12.6167 -0.00064696 17.8494 0.00194088C18.8702 0.00245845 19.76 0.742581 19.9593 1.73476C19.9677 1.7772 19.9865 1.81757 20.0006 1.85897C20 2.33721 20 2.81492 20 3.29264Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2415_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.6364,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCard);
export default __webpack_public_path__ + "static/media/ic-card.87d306ef49b885d7f1fa92891718f8a5.svg";
export { ForwardRef as ReactComponent };